import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Activity Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const ActivityNotifications = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'activity.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template successfully created!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activity.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activity.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        case 'template.duplicated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template successfully duplicated!"
                    type="success"
                    expire="3500"
                />
            );
        default:
            return null;
    }
};

ActivityNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

ActivityNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default ActivityNotifications;
